import React, { useEffect } from "react";

import styles from "./index.module.scss";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { getSettings, setOccupations } from "store/slices";
import SuggestionsBlock from "components/SuggestionsBlock";

import Occupations from "../Occupations";
import Loader from "components/Loader";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { getCareers } from "api/career";
import { ApiResponse } from "constantVariables";
import { decrypt } from "utils/crypto";
import ReportProblem from "pages/Block/ReportProblem";

const CareerDesktop = () => {
  const { dir, language } = useAppSelector(getSettings);
  const { lifeChoice, setLifeChoice } = useLifeChoicePageContext();
  const [message, setMessage] = React.useState("");
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      lifeChoice?.related_careers &&
      lifeChoice?.related_careers.every((item) => typeof item === "string")
    ) {
      (async () => {
        const res = await getCareers(lifeChoice?.related_careers);
        if (res.statusCode === ApiResponse.SUCCESS) {
          let decryptedData = decrypt(res.data);
          setLifeChoice({ ...lifeChoice, related_careers: decryptedData });
          dispatch(setOccupations([decryptedData]));
        } else {
          setMessage("Error while fetching careers");
        }
      })();
    }
  }, [lifeChoice]);

  if (!dir || !language) return null;

  return (
    <div className={`${styles["career-desktop-wrapper"]} | container relative`}>
      {message ? (
        <p className="text-sm text-center mx-auto">{message}</p>
      ) : lifeChoice?.related_careers &&
        lifeChoice?.related_careers.every(
          (item) => typeof item === "string"
        ) ? (
        <Loader open type="block" />
      ) : (
        <>
          <Occupations />
        </>
      )}
      <ReportProblem className="-mb-12" />
      <SuggestionsBlock />
    </div>
  );
};

export default CareerDesktop;
